<template>
	<el-container>
		<el-header>
			<!-- 头部区域 -->
			<MyHeader></MyHeader>
		</el-header>
		<el-container>
			<el-aside width="180px" style="overflow: hidden; padding-top: 24px">
				<MyAside></MyAside>
			</el-aside>
			<el-main style="padding: 0">
				<router-view></router-view>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
// 头部区域组件
import MyHeader from './subcomponents/MyHeader.vue'
// 左侧边栏组件
import MyAside from './subcomponents/MyAside.vue'
export default {
	name: 'MyHome',
	// 注册组件
	components: {
		MyHeader,
		MyAside,
	},
}
</script>

<style>
.el-main {
	padding: 20px 3px !important;
}
</style>